import { useEffect, useState } from 'react'
import './Header.css'
const Header = () => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    const body = document.querySelector('body')
    if (active) body.classList.add('active')
    if (!active) body.classList.remove('active')
  }, [active])

  useEffect(() => {
    window.addEventListener('scroll', () => {
      let header = document.querySelector('.headerBox')
      header.classList.toggle('sticky', window.scrollY > 0)
    })
  }, [])

  return (
    <>
      <div className='mobHeader'>
        <h2 style={{
          fontWeight: 400,
          textTransform: "none",
          marginLeft: '25px'
        }}>RMe</h2>
        <div onClick={() => setActive(!active)} className={`navbtn ${active ? 'active' : ''}`}>
          <div className='lan'></div>
        </div>
      </div>
      <div className='headerBox'>
        <header className={`flex jcc ${active ? 'active' : ''}`}>
          <div className='wrap flex sb aic'>
            <a href='#main'>
              <h1 style={{
                fontWeight: 400,
                textTransform: "none"
              }}>RMe</h1>
            </a>
            <div className='links flex'>
              <a onClick={() => setActive(false)} href='#main'>
                Главная
              </a>
              <a onClick={() => setActive(false)} href='#about'>
                О нас
              </a>
              <a onClick={() => setActive(false)} href='#service'>
                Услуги
              </a>
              <a onClick={() => setActive(false)} href='#works'>
                Работы
              </a>
              <a onClick={() => setActive(false)} href='#partners'>
                Партнеры
              </a>
            </div>
            <a onClick={() => setActive(false)} href='#contact-us'>
              <button>Оставить заявку</button>
            </a>
          </div>
        </header>
      </div>
    </>
  )
}

export default Header
